import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

const CoachWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  ${plume.styles.image.Avatar} {
    box-shadow: ${plume.EFFECTS.SHADOW_2};
    margin-right: 10px;
  }
`

const CoachModal = styled(plume.SmallModal)<{ titleBackgroundColor?: string }>`
  width: 300px;
  box-shadow: ${plume.EFFECTS.SHADOW_2};
  border-radius: 2px 2px 0 0;

  ${plume.styles.modal.Body} {
    display: flex;
    flex-direction: column;
  }
  ${plume.styles.modal.Title} {
    border-radius: 2px 2px 0 0;
  }
  ${plume.styles.button.Button} {
    margin-top: 15px;
  }
  ${plume.LinkAsButton} {
    margin: 0 0 -10px;
    width: auto;
    justify-self: center;
  }
  ${plume.styles.heading.XS} {
    margin-bottom: 20px;
  }
  ${plume.styles.copy.S.regular} {
    margin-bottom: 10px;
  }

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    &::before {
      content: '';
      background-color: ${({ titleBackgroundColor }) => titleBackgroundColor ?? plume.COLORS.PRIMARY_BLUE_500};
      border-radius: 0 0 0 2px;
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      height: 10px;
      left: 27px;
      position: absolute;
      top: -5px;
      transform: rotate(135deg);
      width: 10px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    &::before {
      content: '';
      background-color: ${({ titleBackgroundColor }) => titleBackgroundColor ?? plume.COLORS.PRIMARY_BLUE_500};
      border-radius: 0 0 0 2px;
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      height: 10px;
      left: -4px;
      position: absolute;
      top: 17px;
      transform: rotate(45deg);
      width: 10px;
    }
  }
`

type CoachProps = {
  avatar?: string
  children: React.ReactNode
  className?: string
  closable: boolean
  onAvatarClick?: () => void
  onClose: () => void
  open: boolean
  title: React.ReactNode
  titleBackgroundColor?: string
}

function CoachComponent({
  children,
  className,
  closable,
  onClose,
  open,
  title,
  titleBackgroundColor,
}: CoachProps): React.ReactElement<CoachProps> {
  return (
    <CoachWrapper className={className}>
      <CoachModal
        open={open}
        closable={closable}
        onClose={onClose}
        title={title}
        titleBackgroundColor={titleBackgroundColor}
      >
        {children}
      </CoachModal>
    </CoachWrapper>
  )
}

export const Coach = styled(CoachComponent)<CoachProps>``
